import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CustomerSearchClient } from "../../../../../../Wrap/Api/Customer/CustomerSearch";
import { FullClientDetailClient } from "../../../../../../Wrap/Api/Customer/FullClientDetail";
import { CustomerStatus } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { EntityType } from "../../../../../../Wrap/Constants/Enums/EntityType";
import { RoleType } from "../../../../../../Wrap/Constants/Enums/RoleType";
import { FullClientDetailModel } from "../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { CustomerSearchDispatcher, CustomerSearchStore } from "../Store/Variable";

export interface ICustomerSearchQuery {
    customerId: number;
    customerStatus: CustomerStatus;
    firstName: string;
    lastName: string;
    dateOfBirth: Date;
    TaxIdentifier: string;
    clAccountId: string;
    customerRole: RoleType;
    visibleToAdviserId: number;
    entityId: number;
    entityType: EntityType;
}

export class CustomerSearchAction {
    public static searchCustomers(
        query: ICustomerSearchQuery,
        currentPage,
        count,
        callBack?: (val: any) => void
    ): void {
        const client = new CustomerSearchClient();
        const promise = client.get(
            query.customerId,
            query.customerStatus,
            query.firstName,
            query.lastName,
            JsonDateParser.toJsonDateNoOffset(query.dateOfBirth),
            query.TaxIdentifier,
            query.clAccountId,
            query.customerRole,
            query.entityId,
            query.entityType,
            query.visibleToAdviserId,
            currentPage,
            count
        );
        promise.onSuccess((res) => {
            let data = JSON.parse(JSON.stringify(CustomerSearchStore.getData()));
            if (!data) {data = {};}
            data = res;
            CustomerSearchDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            console.log(data);
            if (callBack) {
                callBack(res);
            }
        });

        promise.onError((err) => {
            CustomerSearchDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getCustomerData(customerId: number, callBack?: (val: FullClientDetailModel) => void): void {
        const client = new FullClientDetailClient();
        const promise = client.get(customerId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => {});
    }
}
